import React from "react";
// css comes in hw_master.css
const SubjectBox = (props) => {
  const isMore = props.subname.length > 8;
  return (
    <div
      className="py-1 px-3 text-center shadow-sm rounded-4 mb-1 "
      style={{
        minWidth: "250px",
        maxWidth: "350px",
        backgroundColor: "#FDEFE3",
        borderTop: "2px solid #8D4B28", // top border
        borderRight: "4px solid #8D4B28", // right border (thicker)
        borderBottom: "1px solid #8D4B28",
        borderLeft: "1px solid #8D4B28",
        borderRadius: "0.75rem",
      }}
    >
      <div className="d-flex flex-column align-items-center mb-1">
        <img
          src={props.sublogo}
          alt={""}
          style={{ height: "32px" }}
          onError={(e) => {
            e.target.src = "/subIcon/ic_png_science.png";
          }}
        />
        <h6
          className="mt-1 fw-bold text-brown mx-auto text-truncate poppins-semibold"
          title={props.subname}
          style={{
            maxWidth: "100%", // allows truncation to work
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            hover: "pointer",
            color: "#8D4B28",
          }}
        >
          {props.subname}
        </h6>
      </div>

      <div className="d-flex justify-content-between gap-2 border-top pt-2 text-muted small fw-semibold ">
        <div className=" d-flex flex-column ">
          <small className="text-sm poppins-semibold ">Published</small>
          <small className="text-dark poppins-semibold">
            {props.started === 0
              ? props.started
              : String(props.started).padStart(2, "0")}
          </small>
        </div>

        <div className=" d-flex flex-column border-start border-end border-dark border-2 px-1">
          <small className="text-nowrap poppins-semibold">On Review</small>
          <small className="text-dark poppins-semibold">
            {props.progress === 0
              ? props.progress
              : String(props.progress).padStart(2, "0")}
          </small>
        </div>

        <div className=" d-flex flex-column">
          <small className="poppins-semibold">Completed</small>
          <small className="text-dark poppins-semibold">
            {props.complateed === 0
              ? props.complateed
              : String(props.complateed).padStart(2, "0")}
          </small>
        </div>
      </div>
    </div>
  );
};

export default SubjectBox;
